export const MESSAGES_TYPES = [
  {
    title: "You have reached your gift card limit",
    message: "You are limited to purchase 25 gift cards per order",
    cta: "CLOSE"
  },
  (brandName) => ({
    title: "Uh oh! We ran out of stock",
    message: `Looks like we no longer have any ${brandName} gift cards at that value.`,
    cta: "CLOSE"
  }),
  (message) => {
    return {
      title: "Uh oh!",
      message,
      cta: "CONTINUE"
    };
  }
];
